import React from 'react';
import { LabeledInput } from '../LabeledInput';
import styles from './styles.module.scss';

export const SearchInput = ({ keyword, setKeyword, placeholder, description }) => (

  <LabeledInput
    className={description ? styles.inputWithDescription : styles.input}
    placeholder={placeholder}
    value={keyword}
    description={description}
    onChange={(e) => {
      setKeyword(e.target.value);
    }}
  />

);
